import React, { useState } from "react";
import classNames from "classnames";
import { plusIcon, minusIcon } from "../../images";
import styles from "../faq/faq.module.css";

const TechAccordion = ({ faq }) => {
  const [openIndex, setOpenIndex] = useState(null);

  const handleToggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  if (!faq || faq.length === 0) return null;

  return (
    <div>
      {faq.map((item, idx) => (
        <div
          className={classNames(styles["question_answer"])}
          key={item.id || idx}
        >
          <div
            className={styles["question_item"]}
            onClick={() => handleToggle(idx)}
          >
            <div className={styles["icon_div"]}>
              {openIndex === idx ? (
                <img src={minusIcon} alt="minus icon" />
              ) : (
                <img src={plusIcon} alt="plus icon" />
              )}
            </div>
            <div className={styles["question"]}>{item.question}</div>
          </div>
          {openIndex === idx && (
            <div className={styles["answer"]}>{item.answer}</div>
          )}
        </div>
      ))}
    </div>
  );
};

export default TechAccordion;
